import React, {useState} from 'react';
import logo from './fetch-logo.svg';
import './App.css';
import detectEthereumProvider from '@metamask/detect-provider';
import Web3 from "web3";

function App() {
  const metaMaskInstalled = (typeof window.ethereum !== 'undefined')
  const [provider, setProvider] = useState(null);
  const [web3, setWeb3] = useState(null);
  const [address, setAddress] = useState(null);
  const [message, setMessage] = useState('');
  const [signedMessage, setSignedMessage] = useState('');

  const selectAddress = (accounts) => {
    if (accounts.length > 0) {
      setAddress(accounts[0])
    } else {
      setAddress(null)
    }
  }

  if (metaMaskInstalled) {
    window.ethereum.on('accountsChanged', function (accounts) {
      selectAddress(accounts)
    });

    if (web3 === null) {
      detectEthereumProvider()
        .then((provider) => {
          const web3 = new Web3(provider)
          setWeb3(web3)
          setProvider(provider);
        })
    }
  }

  if (!metaMaskInstalled) {
    return (
      <div className="App">
        <div className="Header">
          <img src={logo} alt="Fetch.ai Logo" height={80}/>
        </div>
        <div className="AppBoxes">
          <div className="AppInput">
            <h1>MetaMask Required!</h1>
            <p>This website needs the MetaMask plugin to be installed. Please install it and try again.</p>
          </div>
        </div>
      </div>
    );
  }

  if (address === null && web3 === null) {
    return (
      <div className="App">
        <div className="Header">
          <img src={logo} alt="Fetch.ai Logo" height={80}/>
        </div>
        <div className="AppBoxes">
          <div className="AppInput">
            <h1>Initialising...</h1>
            <p>Just give us a moment</p>
          </div>
        </div>
      </div>
    );
  }

  if (address === null && web3 !== null) {
    const onConnect = async () => {
      const accounts = await provider.request({method: 'eth_requestAccounts'});
      selectAddress(accounts)
    }

    return (
      <div className="App">
        <div className="Header">
          <img src={logo} alt="Fetch.ai Logo" height={80}/>
        </div>
        <div className="AppBoxes">
          <div className="AppInput">
            <h1>Welcome!</h1>
            <p>Please click the connect button to connect MetaMask to this application</p>
            <button onClick={onConnect} className="SignBtn">Connect</button>
          </div>
        </div>
      </div>
    );
  }

  const onMessageUpdate = (event) => {
    setMessage(event.target.value)
  }

  const onSign = async () => {
    // skip empty messages
    if (message.length === 0) {
      setSignedMessage('');
      return;
    }

    const signedMsg = await web3.eth.personal.sign(message, address)

    setSignedMessage(signedMsg);
  };

  const signedBtnDisabled = message.length === 0
  const signedBtnClass = signedBtnDisabled ? "SignBtn DisabledBtn" : "SignBtn"

  return (
    <div className="App">
      <div className="Header">
        <img src={logo} alt="Fetch.ai Logo" height={80}/>
      </div>
      <div className="AppBoxes">
        <div className="AppInput">
          <label className="Label">Ethereum Address</label>
          <input type="text" value={web3.utils.toChecksumAddress(address)} readOnly={true} className="Address"/>

          <label className="Label">Agent World Address</label>
          <input type="text" value={message} placeholder="Test Network Address" onChange={onMessageUpdate}
                 className="Message"/>
          <button disabled={signedBtnDisabled} onClick={onSign} className={signedBtnClass}>Sign!</button>

          <label className="Label">Signature</label>
          <textarea readOnly={true} className="Signature" cols={45} value={signedMessage}/>
        </div>
      </div>
    </div>
  );
}

export default App;
